<div class="p-3 rounded-3">
  <div class="row mb-2">
    <div class="col-12 mb-3">
      <div class="titletoptables">
        <div class="leftsideicons">
          <img src="../../assets/image/payment-icon.png" alt="payment" onkeydown="" />
        </div>
        <h3>{{ "Transaction Details" }}</h3>
      </div>
    </div>

    <div class="row position">
      <div class="col-md-12 kt-margin-bottom-20-mobile" style="display:flex;">
        <div class="col-md-2">
          <div class="srchgrid texttarget">
            <input class="searchtextbox" matInput (keyup)="filterData($any($event.target).value)" [value]="searchString"
              placeholder="Search" autocomplete="off">
            <div class="closeicon" (keydown.enter)="clearList()" (click)="clearList()"> <span
                aria-hidden="true">&times;</span> </div>
          </div>
        </div>
        <div class="col-md-10 toogle">
          <div class="btn-group-offer">
            <mat-button-toggle-group class="toogleBtn" style="border-radius:10px; --mat-standard-button-toggle-selected-state-text-color: white; --mat-standard-button-toggle-selected-state-icon-color: white;" [value]="IsnotZero"
              (change)="changeToggleVisit($event)">
              <mat-button-toggle [value]="true">Paid Subscription</mat-button-toggle>
              <mat-button-toggle [value]="false">Free Subscription</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="position">
    <kendo-grid #grid [loading]='kendoLoading' [data]="gridData" [filter]="state.filter" [sortable]="{mode: 'single'}"
      [columnMenu]="{ filter: true }" [pageSize]="state.take" [skip]="state.skip"
      [pageable]="gridData?.data?.length && gridData.data.length > 0 ? pageableWithAll : false"
      (pageChange)="pageChange($event)" [sort]="sort" (columnVisibilityChange)="onColumnVisibilityChange(grid)"
      (sortChange)="gridData ? sortChange($event): null" [resizable]="true" [reorderable]="true" filterable="menu"
      [filter]="state.filter" [selectable]="true" (dataStateChange)="gridData ? dataStateChange($event): null"
      [navigable]="true" [height]="gridHeight">
      <kendo-grid-column field="TransactionNumber" [width]="100" title="Transaction Number">
      </kendo-grid-column>
      <kendo-grid-column field="TransactionTypeName" [width]="100" title="Transaction Type">
      </kendo-grid-column>
      <kendo-grid-column field="Date" [width]="100" title="Date">
      </kendo-grid-column>
      <kendo-grid-column field="CreditCardNumber" [width]="100" title="Card Number">
      </kendo-grid-column>
      <kendo-grid-column field="TotalAmount" [width]="100" title="Total Amount">
      </kendo-grid-column>
      <kendo-grid-column field="TransactionCurrencyName" [width]="100" title="Currency Type">
      </kendo-grid-column>
      <kendo-grid-column field="TransactionStatusStr" [width]="60" title="Status">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span class="badge"
            [ngClass]="{' badge-danger': dataItem.TransactionStatusStr === 'UnPaid','badge-success': dataItem.TransactionStatusStr === 'Paid'}">
            {{ dataItem.TransactionStatusStr }}
          </span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="SubscriptionPlanId" [width]="100" title="Subscription Plan">
      </kendo-grid-column>
      <kendo-grid-column field="UserName" [width]="100" title="Doctor Name">
      </kendo-grid-column>
      <kendo-grid-column field="CompanyName" [width]="100" title="Clinic Name">
      </kendo-grid-column>
      <kendo-grid-column field="CompanyAddress" [width]="100" title="Clinic Address">
      </kendo-grid-column>
      <kendo-grid-column field="IPAddress" [width]="100" title="IP Address">
      </kendo-grid-column>
    </kendo-grid>
  </div>
</div>